import React from 'react';
// useLocation hook
import { useLocation } from 'react-router-dom';
// useFetch hook
import useFetch from '../hooks/useFetch';
// components
import Product from '../components/Product';
import ThemedSuspense from "../components/ThemedSuspense";

const Search = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchTerm = searchParams.get('query');

  // get products based on search term
  const { data, isLoading } = useFetch(
    `/products?search=${searchTerm}`
  );
  if (isLoading) {
    return <><ThemedSuspense /></>
  }
  return (
    <div className='mb-[30px] pt-24 lg:pt-4 xl:pt-0'>
      <div className='container mx-auto'>
        <div className='flex gap-x-[30px]'>
          <div>
            {/* title */}
            <div className='py-3 text-xl uppercase text-center lg:text-left'>
              {data?.length > 0
                ? `${data.length} результаты для ${searchTerm}`
                : `результатов не найдено для ${searchTerm}`}
            </div>
            {/* products grid */}
            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-[15px] md:gap-[30px]'>
              {data?.map((product) => {
                return <Product product={product} key={product.id} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
